import React, { useState, useMemo } from "react";
import styled from "styled-components";
import searchIcon from "../../../assets/image/icons/search.svg"; // adjust path

const Table = ({ columns, data, onRowClick, highlightRow }) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [searchTerm, setSearchTerm] = useState("");

  const sortedAndFilteredData = useMemo(() => {
  if (!Array.isArray(data)) return []; // <-- safeguard

  let filtered = data.filter(row =>
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  if (sortConfig.key) {
    filtered.sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];
      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }

  return filtered;
}, [data, searchTerm, sortConfig]);


  const requestSort = key => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  return (
    <div>
      {/* Search Bar */}
      <SearchBar>
        <img src={searchIcon} alt="search" />
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </SearchBar>

      {/* Table */}
      <StyledTable>
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th
                key={idx}
                onClick={() => col.sortable && requestSort(col.key)}
                style={{ cursor: col.sortable ? "pointer" : "default" }}
              >
                {col.label}
                {col.sortable && sortConfig.key === col.key && (
                  <SortIndicator>{sortConfig.direction === "asc" ? " ▲" : " ▼"}</SortIndicator>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedAndFilteredData.map((row, idx) => {
            const isSelected = highlightRow ? highlightRow(row) : false;
            return (
              <tr
                key={idx}
                className={isSelected ? "selected" : ""}
                onClick={() => onRowClick && onRowClick(row)}
              >
                {columns.map((col, cIdx) => (
                  <td key={cIdx}>
                    {col.render ? col.render(row) : row[col.key]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </StyledTable>
    </div>
  );
};

export default Table;

/* Styles */
const SearchBar = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 10px;
  background: #fff;

  input {
    border: none;
    outline: none;
    flex: 1;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  thead {
    background: #f9f9f9;
  }

  th, td {
    padding: 8px 10px;
    border-bottom: 1px solid #e5e5e5;
    text-align: left;
  }

  th {
    font-weight: 600;
    color: #444;
  }

  tr.selected {
    background: #e6f2ff;
  }

  tr:hover {
    background: #f5f5f5;
    cursor: pointer;
  }
`;

const SortIndicator = styled.span`
  font-size: 12px;
  color: #666;
`;
